<template>
  <div class="news-carousel-container">
    <!-- 轮播主体 -->
    <div class="carousel-main" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <!-- 左侧图片轮播（可点击跳转） -->
      <div class="carousel-img-wrap">
        <transition-group class="carousel-img-list" tag="div"
          :style="{ transform: `translateX(-${currentIndex * 100}%)` }" name="carousel-img">
          <div v-for="(item, index) in carouselData" :key="`img-${index}`" class="carousel-img-item"
            @click="handleItemClick(item)">
            <img :src="item.imgUrl" alt="新闻图片" class="carousel-img" />
          </div>
        </transition-group>

        <!-- 图片指示器（居左+大间隙+#c10000选中色） -->
        <div class="carousel-indicator">
          <span v-for="(item, index) in carouselData" :key="`indicator-${index}`" class="indicator-dot"
            :class="{ active: index === currentIndex }" @click="handleIndicatorClick(index)"></span>
        </div>
      </div>

      <!-- 右侧新闻列表（可点击+hover效果） -->
      <div class="news-list-wrap">
        <div v-for="(item, index) in carouselData" :key="`news-${index}`" class="news-item" :class="{
          active: index === currentIndex,
          hover: hoverIndex === index
        }" @click="handleItemClick(item)" @mouseenter="handleNewsHover(index)" @mouseleave="handleNewsHover(-1)">
          <!-- 日期块（默认白背景+选中#c10000） -->
          <div class="news-date">
            <span class="date-month-day">{{ item.date.monthDay }}</span>
            <span class="date-year">{{ item.date.year }}</span>
          </div>
          <!-- 内容块 -->
          <div class="news-content">
            <h3 class="news-title-text">{{ item.title }}</h3>
            <p class="news-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 查看更多按钮 -->
    <div class="view-more-wrap">
      <button class="view-more-btn" @click="handleViewMore">查看更多 &gt;</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsSyncCarousel",
  props: {
    carouselData: {
      type: Array,
      required: true,
      //   validator: (val) => {
      //     return val.length > 0 && val.every(
      //       (item) =>
      //         item.imgUrl &&
      //         item.title &&
      //         item.desc &&
      //         item.link && // 新增：校验跳转链接
      //         item.date &&
      //         item.date.monthDay &&
      //         item.date.year
      //     );
      //   },
    },
    interval: {
      type: Number,
      default: 3000,
    },
    // 查看更多跳转链接
    viewMoreLink: {
      type: String,
      default: "#",
    },
  },
  data() {
    return {
      currentIndex: 0,
      timer: null,
      hoverIndex: -1, // 新增：记录hover的新闻项索引
    };
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    startAutoPlay() {
      this.clearTimer();
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.carouselData.length;
      }, this.interval);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleMouseEnter() {
      this.clearTimer();
    },
    handleMouseLeave() {
      this.startAutoPlay();
    },
    handleIndicatorClick(index) {
      this.currentIndex = index;
    },
    // 新增：新闻项/图片点击跳转
    handleItemClick(v) {
      if (v) {
        if (v.hasLink == "1") {
          window.open(v["link"], "_blank"); // 在新窗口打开外链接
        } else {
          this.$router.push({
            name: "newsDetail",
            params: {
              id: v.id,
              cid: v.cid,
            },
          });
        }
      }
    },
    // 新增：处理文字项hover
    handleNewsHover(index) {
      this.hoverIndex = index;
      // hover时暂停轮播
      if (index !== -1) {
        this.clearTimer();
      } else {
        this.startAutoPlay();
      }
    },
    // 新增：查看更多点击
    handleViewMore() {
      let id = JSON.parse(sessionStorage.getItem("listTit"))[3].id;
      this.$router.replace({ name: "news", query: { id } });
    },
  },
};
</script>

<style scoped>
/* 容器整体 */
.news-carousel-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 标题区 */
.news-title-wrap {
  text-align: center;
  margin-bottom: 20px;
}

.news-title {
  font-size: 24px;
  color: #333;
  margin: 0 0 5px 0;
}

.news-subtitle {
  font-size: 14px;
  color: #999;
  margin: 0;
}

/* 轮播主体 */
.carousel-main {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

/* 左侧图片区域 */
.carousel-img-wrap {
  flex: 1.2;
  position: relative;
  overflow: hidden;
  height: 300px;
  cursor: pointer;
  /* 点击指针 */
}

.carousel-img-list {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
}

.carousel-img-item {
  flex: 0 0 100%;
  height: 100%;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease;
}

.carousel-img-item:hover .carousel-img {
  opacity: 0.95;
  /* 图片hover轻微透明 */
}

/* 图片指示器（居左+大间隙+#c10000选中色） */
.carousel-indicator {
  position: absolute;
  bottom: 15px;
  left: 20px;
  display: flex;
  gap: 15px;
}

.indicator-dot {
  width: 10px;
  height: 10px;
  background-color: #ccc;
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.indicator-dot.active {
  background-color: #c10000;
}

/* 右侧新闻列表 */
.news-list-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 新闻项（仅上下边框+hover/active区分） */
.news-item {
  display: flex;
  gap: 15px;
  padding: 15px 10px;
  background-color: #fff;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-left: none;
  border-right: none;
  margin-bottom: -1px;
  cursor: pointer;
  transition: all 0.3s ease;
  /* 过渡动画 */
}

/* 第一个/最后一个项边框优化 */
.news-item:first-child {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.news-item:last-child {
  border-bottom: 1px solid #eee;
}

/* 选中效果（滑动/点击） */
.news-item.active {
  background-color: #f8f8f8;
}

.news-item.active .news-date {
  background-color: #c10000;
  color: #fff;
}

/* hover效果（与选中区分） */
.news-item.hover {
  background-color: #faf0f0;
  /* 浅红背景，区别于选中的浅灰 */
}

.news-item.hover .news-date {
  background-color: #e86666;
  /* 浅红色，区别于选中的#c10000 */
  color: #fff;
}

/* 日期块 */
.news-date {
  width: 60px;
  height: 60px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #333;
  border: 1px solid #eee;
  transition: all 0.3s ease;
}

.date-month-day {
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
}

.date-year {
  font-size: 14px;
  margin-top: 5px;
}

/* 新闻内容块 */
.news-content {
  flex: 1;
}

.news-title-text {
  font-size: 16px;
  color: #333;
  margin: 0 0 5px 0;
  font-weight: 600;
  transition: color 0.3s ease;
}

.news-item.hover .news-title-text {
  color: #c10000;
  /* hover时标题变红 */
}

.news-desc {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 查看更多按钮 */
.view-more-wrap {
  margin: 0 auto;
  width: 200px;
  height: 60px;
  font-size: 14px;
  border: 1px solid #d5d5d5;
  text-align: center;
  line-height: 60px;
  margin-top: 44px;
}

.view-more-btn {
  padding: 8px 25px;
  background-color: #fff;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.view-more-btn:hover {
  border-color: #c10000;
  color: #c10000;
  background-color: #faf0f0;
}
</style>


// WEBPACK FOOTER //
// src/components/left_right_carousel.vue